import { ShieldAlert } from "lucide-react";

export default function SafetyBanner() {
  return (
    <div
      data-testid="safety-banner"
      className="rounded-sm p-4 flex items-start gap-3 border"
      style={{
        backgroundColor: "rgba(31,93,52,0.06)",
        borderColor: "rgba(31,93,52,0.25)",
      }}
    >
      <ShieldAlert className="h-5 w-5 mt-0.5 flex-shrink-0" style={{ color: "var(--terracotta)" }} />
      <div>
        <div className="overline" style={{ color: "var(--terracotta)" }}>Applicant safety</div>
        <div className="mt-1 text-sm leading-relaxed" style={{ color: "var(--ink-soft)" }}>
          AddVendTour never asks you to pay booth fees outside the platform. If an organizer
          contacts you off-platform for money, wire transfers, or gift cards — that&rsquo;s a red flag.
          Use the <strong>Report event</strong> button below and we&rsquo;ll investigate.
        </div>
      </div>
    </div>
  );
}
